(function () {
  if (window.__cartQuantityAnalyticsInit) return;
  window.__cartQuantityAnalyticsInit = true;

  var qtyByIndex = new Map();
  var qtyByKey = new Map();
  var metaByIndex = new Map();
  var metaByKey = new Map();

  function cloneMap(map) {
    var copy = new Map();
    map.forEach(function (value, key) {
      copy.set(key, value);
    });
    return copy;
  }

  function getSource() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      return 'cart_drawer';
    }
    if (document.getElementById('main-cart') || document.querySelector('.js-cart-items:not(.js-cart-drawer-items)')) {
      return 'cart_page';
    }
    if (document.querySelector('.js-cart-drawer-items')) {
      return 'cart_drawer';
    }
    return 'cart_drawer';
  }

  function readMetaFromElement(el) {
    if (!el) return null;
    return {
      product_id: el.dataset.productId || '',
      variant_id: el.dataset.variantId || '',
      product_title: el.dataset.productTitle || '',
      sku: el.dataset.sku || '',
      price: el.dataset.price ? Number(el.dataset.price) : null,
      currency:
        el.dataset.currency ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        '',
    };
  }

  function escapeAttr(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function findLineElement(lineIndex, lineKey) {
    if (lineIndex != null) {
      var byIndex = document.querySelector(
        '.js-quantity-input[data-index="' + lineIndex + '"], .js-cart-remove-button[data-index="' + lineIndex + '"]'
      );
      if (byIndex) return byIndex;
    }
    if (lineKey) {
      var safeKey = escapeAttr(lineKey);
      return document.querySelector(
        '.js-quantity-input[data-key="' + safeKey + '"], .js-cart-remove-button[data-key="' + safeKey + '"]'
      );
    }
    return null;
  }

  function snapshotQuantities() {
    qtyByIndex.clear();
    qtyByKey.clear();
    metaByIndex.clear();
    metaByKey.clear();

    document.querySelectorAll('.js-quantity-input[data-index]').forEach(function (input) {
      var index = String(input.dataset.index);
      var key = input.dataset.key ? String(input.dataset.key) : '';
      var quantity = parseInt(input.value, 10);
      if (Number.isNaN(quantity)) return;

      qtyByIndex.set(index, quantity);
      metaByIndex.set(index, readMetaFromElement(input));

      if (key) {
        qtyByKey.set(key, quantity);
        metaByKey.set(key, readMetaFromElement(input));
      }
    });

    document.querySelectorAll('.js-cart-remove-button[data-index]').forEach(function (btn) {
      var index = String(btn.dataset.index);
      var key = btn.dataset.key ? String(btn.dataset.key) : '';
      if (!metaByIndex.has(index)) {
        metaByIndex.set(index, readMetaFromElement(btn));
      }
      if (key && !metaByKey.has(key)) {
        metaByKey.set(key, readMetaFromElement(btn));
      }
      if (key && !qtyByKey.has(key) && qtyByIndex.has(index)) {
        qtyByKey.set(key, qtyByIndex.get(index));
      }
    });
  }

  function publishEvent(eventName, payload) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      return;
    }
    window.Shopify.analytics.publish(eventName, payload);
  }

  function handleQuantityChange(previousQty, nextQty, meta) {
    if (previousQty == null || nextQty == null || previousQty === nextQty) return;
    if (!meta) meta = {};

    var delta = Math.abs(nextQty - previousQty);
    var payload = {
      product_id: meta.product_id || '',
      variant_id: meta.variant_id || '',
      product_title: meta.product_title || '',
      sku: meta.sku || '',
      quantity: delta,
      quantity_after: nextQty,
      price: meta.price,
      currency: meta.currency || '',
      source: getSource(),
    };

    if (nextQty > previousQty) {
      publishEvent('product_quantity_added', payload);
    } else {
      publishEvent('remove_from_cart', payload);
    }
  }

  function isCartChangeUrl(url) {
    if (!url) return false;
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    var href = String(url);
    return href.indexOf(changeUrl) !== -1 || href.indexOf(updateUrl) !== -1 || href.indexOf('/cart/change') !== -1 || href.indexOf('/cart/update') !== -1;
  }

  function parseRequestBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function getRequestBody(init, input) {
    if (init && init.body != null) return init.body;
    return null;
  }

  function findResponseItemByLine(cart, lineIndex) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var index = Number(lineIndex) - 1;
    if (index < 0 || index >= cart.items.length) return null;
    return cart.items[index];
  }

  function findResponseItemByKey(cart, lineKey) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key) === String(lineKey)) return cart.items[i];
    }
    return null;
  }

  function onCartMutationSuccess(requestBody, cart, snapshot) {
    if (!requestBody || !snapshot) return;

    var snapQtyByIndex = snapshot.qtyByIndex;
    var snapQtyByKey = snapshot.qtyByKey;
    var snapMetaByIndex = snapshot.metaByIndex;
    var snapMetaByKey = snapshot.metaByKey;

    if (requestBody.line != null && requestBody.quantity != null) {
      var index = String(requestBody.line);
      var previousQty = snapQtyByIndex.has(index) ? snapQtyByIndex.get(index) : null;
      var requestedQty = Number(requestBody.quantity);
      var lineItem = findResponseItemByLine(cart, requestBody.line);
      var actualQty;

      if (requestedQty === 0) {
        actualQty = lineItem ? Number(lineItem.quantity) : 0;
      } else if (lineItem) {
        actualQty = Number(lineItem.quantity);
      } else {
        actualQty = requestedQty;
      }

      if (previousQty == null || actualQty === previousQty) return;

      var meta = snapMetaByIndex.get(index) || readMetaFromElement(findLineElement(index, null));
      handleQuantityChange(previousQty, actualQty, meta);
      return;
    }

    if (requestBody.updates && typeof requestBody.updates === 'object') {
      Object.keys(requestBody.updates).forEach(function (key) {
        var previousQty = snapQtyByKey.has(key) ? snapQtyByKey.get(key) : null;
        var requestedQty = Number(requestBody.updates[key]);
        var lineItem = findResponseItemByKey(cart, key);
        var actualQty;

        if (requestedQty === 0) {
          actualQty = lineItem ? Number(lineItem.quantity) : 0;
        } else if (lineItem) {
          actualQty = Number(lineItem.quantity);
        } else {
          actualQty = requestedQty;
        }

        if (previousQty == null || actualQty === previousQty) return;

        var meta = snapMetaByKey.get(key) || readMetaFromElement(findLineElement(null, key));
        handleQuantityChange(previousQty, actualQty, meta);
      });
    }
  }

  function captureSnapshot() {
    return {
      qtyByIndex: cloneMap(qtyByIndex),
      qtyByKey: cloneMap(qtyByKey),
      metaByIndex: cloneMap(metaByIndex),
      metaByKey: cloneMap(metaByKey),
    };
  }

  // Record qty BEFORE plus/minus mutates the input (capture phase, before base-script stepUp/stepDown)
  function bindQuantityButtonCapture() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target && event.target.closest && event.target.closest('.m-quantity__button');
        if (!button) return;
        var ticker = button.closest('.js-quantity-ticker');
        if (!ticker) return;
        var input = ticker.querySelector('.js-quantity-input[data-index]');
        if (!input) return;

        var index = String(input.dataset.index);
        var key = input.dataset.key ? String(input.dataset.key) : '';
        var quantity = parseInt(input.value, 10);
        if (Number.isNaN(quantity)) return;

        qtyByIndex.set(index, quantity);
        metaByIndex.set(index, readMetaFromElement(input));
        if (key) {
          qtyByKey.set(key, quantity);
          metaByKey.set(key, readMetaFromElement(input));
        }
      },
      true
    );

    document.addEventListener(
      'focusin',
      function (event) {
        var input = event.target;
        if (!input || !input.classList || !input.classList.contains('js-quantity-input')) return;
        var index = String(input.dataset.index);
        var key = input.dataset.key ? String(input.dataset.key) : '';
        var quantity = parseInt(input.value, 10);
        if (Number.isNaN(quantity)) return;

        qtyByIndex.set(index, quantity);
        metaByIndex.set(index, readMetaFromElement(input));
        if (key) {
          qtyByKey.set(key, quantity);
          metaByKey.set(key, readMetaFromElement(input));
        }
      },
      true
    );
  }

  function wrapFetch() {
    if (typeof window.fetch !== 'function') return;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = getRequestUrl(input);
      var body = getRequestBody(init, input);
      var parsedBody = isCartChangeUrl(url) ? parseRequestBody(body) : null;
      var shouldTrack =
        !!parsedBody && (parsedBody.line != null || (parsedBody.updates && typeof parsedBody.updates === 'object'));
      var snapshot = shouldTrack ? captureSnapshot() : null;

      var responsePromise = originalFetch(input, init);

      if (!shouldTrack) return responsePromise;

      responsePromise
        .then(function (response) {
          if (!response || !response.ok) return null;
          // Match cart-script: text() + JSON.parse (more reliable than response.json())
          return response
            .clone()
            .text()
            .then(function (text) {
              try {
                return JSON.parse(text);
              } catch (e) {
                return null;
              }
            });
        })
        .then(function (cart) {
          if (!cart) return;
          onCartMutationSuccess(parsedBody, cart, snapshot);
        })
        .catch(function () {})
        .then(function () {
          window.setTimeout(snapshotQuantities, 0);
          window.setTimeout(snapshotQuantities, 300);
        });

      return responsePromise;
    };
  }

  function bindCartUpdateListener() {
    if (window.WhatSub && typeof window.WhatSub.subscribe === 'function') {
      window.WhatSub.subscribe('CART_UPDATE', function () {
        snapshotQuantities();
      });
      window.WhatSub.subscribe('ADD_TO_CART', function () {
        window.setTimeout(snapshotQuantities, 0);
        window.setTimeout(snapshotQuantities, 300);
      });
    }
  }

  function init() {
    snapshotQuantities();
    bindQuantityButtonCapture();
    wrapFetch();
    bindCartUpdateListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
